export default {"src":"/stays/_next/static/media/AirbnbRating.e40bae7e.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};